export default "__VITE_ASSET__Dlwp96lT__"